document.addEventListener('click',function(e){
  var mb=e.target.closest('[data-au-menu]');
  if(mb){var nv=document.querySelector('[data-au-nav]');if(nv)nv.hidden=!nv.hidden;}
  var z=e.target.closest('[data-au-size]');
  if(z){var box=z.closest('[data-au-sizes]');
    box.querySelectorAll('[data-au-size]').forEach(function(b){b.classList.toggle('au-size-btn--on',b===z);});
    var out=document.querySelector('[data-au-sizeout]');if(out)out.textContent=z.dataset.auSize;
    var hid=document.querySelector('[data-au-sizeinput]');if(hid)hid.value=z.dataset.auSize;}
  var s=e.target.closest('[data-sq-tint]');
  if(s){document.documentElement.style.setProperty('--au-latte',s.dataset.auTint);
    document.documentElement.style.setProperty('--au-latte-soft',s.dataset.auTintSoft||s.dataset.auTint);
    var g=s.closest('[data-au-swatches]');
    if(g){g.querySelectorAll('.au-swatch').forEach(function(b){b.setAttribute('aria-checked',b===s?'true':'false');});
      var lbl=g.parentNode.querySelector('[data-au-colorname]');
      if(lbl)lbl.textContent=s.getAttribute('title')||'';}
  }
  var t=e.target.closest('[data-au-thumb]');
  if(t){var tr=t.closest('.au-gal').querySelector('.au-gal__track');
    if(tr)tr.scrollTo({left:tr.clientWidth*parseInt(t.dataset.auThumb,10),behavior:'smooth'});}
  var f=e.target.closest('[data-au-filter]');
  if(f){var wrap=f.closest('[data-au-filters]');
    wrap.querySelectorAll('[data-au-filter]').forEach(function(b){b.classList.toggle('sq-chip--on',b===f);});
    var key=f.dataset.auFilter,n=0;
    document.querySelectorAll('[data-au-item]').forEach(function(it){
      var ok=key==='all'||it.dataset.auItem===key;it.style.display=ok?'':'none';if(ok)n++;});
    var c=document.querySelector('[data-au-count]');if(c)c.textContent=n;}
  var tb=e.target.closest('[data-au-tab]');
  if(tb){var box=tb.closest('[data-au-tabs]');
    box.querySelectorAll('[data-au-tab]').forEach(function(b){b.classList.toggle('sq-chip--on',b===tb);});
    box.parentNode.querySelectorAll('[data-au-panel]').forEach(function(p){
      p.hidden=p.dataset.auPanel!==tb.dataset.auTab;});}
});
document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
  var optionSelects = form.querySelectorAll('select[name^="options["]');
  var variantSelect = form.querySelector('select[name="id"]');

  if (!variantSelect || !optionSelects.length) return;

  function updateVariant(){
    var selected = Array.from(optionSelects).map(function(select){
      return select.value;
    });

    var match = Array.from(variantSelect.options).find(function(option){
      return (option.dataset.options || '').split('||').every(function(value, i){
        return value === selected[i];
      });
    });

    if (match) {
      variantSelect.value = match.value;
    }
  }

  optionSelects.forEach(function(select){
    select.addEventListener('change', updateVariant);
  });

  updateVariant();
});